// extracted by mini-css-extract-plugin
export default {"IssueBodyLoadingContainer":"IssueBodyLoading-module__IssueBodyLoadingContainer__M6qAgo2"};